import React, { useCallback, useEffect } from 'react';

import { Loading } from 'src/components/common/loading/Loading';

import { onOpenChange } from '../QueryTraceCard';
import { Trace } from '../trace/Trace';
import { TraceTree } from '../trace/TraceTree';

import { useDecodeTrace } from './useDecodeTrace';

export const TraceProtobuf = ({
  trace,
  operationName,
  rowHoverColor,
}: {
  trace: string;
  operationName: string;
  rowHoverColor?: string;
}) => {
  const traceRoot = useDecodeTrace({ trace, operationName });
  const traceTree = traceRoot && new TraceTree(traceRoot);
  const [openNodes, setOpenNodes] = React.useState<Set<string>>(new Set());

  const onOpenChangeCallback = useCallback(
    (nodeId: string) => onOpenChange(nodeId, openNodes, setOpenNodes),
    [openNodes],
  );

  useEffect(() => {
    if (openNodes.size === 0) {
      setOpenNodes(new Set(traceTree?.criticalPath.map((n) => n.id)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openNodes]);

  return traceTree ? (
    <Trace
      traceTree={traceTree}
      rowHoverColor={rowHoverColor}
      openNodes={openNodes}
      onOpenChange={onOpenChangeCallback}
    />
  ) : (
    <Loading />
  );
};
